<template>
  <with-loader id="customer-request-detail" :loading="isLoading" class="h-full" trigger-loader-on-mount use-as-overlay>
    <form
      class="flex flex-col justify-between bg-white text-gray-dark border-solid border-l border-0 border-soft h-full"
      @submit.prevent
    >
      <div class="flex flex-col pt-1 pb-5 h-full px-4 overflow-auto">
        <div v-if="messageEmailSubject" class="flex flex-col">
          <span class="mt-4 font-bold text-black">Subject</span>
          <transition name="slide-fade" mode="out-in">
            <span :key="`subject-${messageId}`" class="break-all">
              {{ messageEmailSubject }}
            </span>
          </transition>
        </div>

        <span class="mt-4 font-bold text-black">Request</span>
        <transition name="slide-fade" mode="out-in">
          <span :key="`request-${messageId}`" class="break-all" v-html="sanitizeRichText(formData.firstRequest || '')"/>
        </transition>

        <template v-if="originalIntent">
          <span class="mt-4 font-bold text-black">Answer</span>
          <transition v-if="originalAnswer" name="slide-fade" mode="out-in">
            <span class="inline-block">
              <router-link
                :key="`answer-${messageId}`"
                :to="`/bots/${botId}/answers/${originalAnswer.id}`"
                target="_blank"
                class="hover:underline"
              >
                {{ originalAnswer.name }}
              </router-link>
            </span>
          </transition>
        </template>
      </div>
    </form>
  </with-loader>
</template>

<script>
import WithLoader from '@/components/common/WithLoader.vue'
import analyticsFilterModule from '@/store/modules/analytics-filter.module'
import contentUtils from '@/utils/content.utils'

export default {
  name: 'CustomerRequestDetail',

  components: {
    WithLoader
  },

  props: {
    formData: {
      type: Object,
      required: true
    },
    answersByIntentId: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    bot: analyticsFilterModule.getBot,

    botId() {
      return this.bot?.id
    },

    messageId() {
      return this.formData.messageId
    },

    messageEmailSubject() {
      return this.formData.subject
    },

    originalIntent() {
      return this.formData.intent || null
    },

    originalAnswer() {
      if (!this.originalIntent) return null
      const normalizedIntent = this.originalIntent === '__unknown' ? 'unknown' : this.originalIntent
      return this.answersByIntentId[normalizedIntent] || null
    }
  },

  methods: {
    sanitizeRichText(richText) {
      return contentUtils.sanitizeRichText(richText)
    }
  }
}
</script>
